import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createPageUrl } from "../utils";

export default function IntroCinematic() {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const finish = () => {
    // After cinematic, go to mode selection (not directly to wizard)
    navigate('/mode-select');
  };

  const enableSound = () => {
    const v = videoRef.current;
    if (!v || !showOverlay) return;
    
    v.muted = false;
    v.currentTime = 0;
    v.play();
    setShowOverlay(false);
  };

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.onended = finish;

    const handleKeyDown = (e) => {
      enableSound();
    };

    const handleClick = () => {
      enableSound();
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('click', handleClick);
    };
  }, [showOverlay]);

  return (
    <div style={{ width: '100%', height: '100%', backgroundColor: 'black', position: 'relative', overflow: 'hidden' }}>
      <video
        ref={videoRef}
        src="https://github.com/zachseven/airlineops-assets/releases/download/aops/AOps.mp4?raw=1"
        autoPlay
        muted
        playsInline
        className="intro-video"
      />

      {showOverlay && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000
          }}
        >
          <div style={{ color: 'white', fontSize: '24px', textAlign: 'center', fontFamily: 'JetBrains Mono, monospace' }}>
            Press any key or click to enable sound
          </div>
        </div>
      )}

      <button
        onClick={finish}
        style={{
          position: 'fixed',
          top: '16px',
          right: '16px',
          color: 'white',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          padding: '8px 16px',
          borderRadius: '4px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '14px',
          zIndex: 10001
        }}
      >
        Skip Intro
      </button>
    </div>
  );
}